import React, { useState } from 'react';
import './Header.css';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="container">
        <div className="header__content">
          <div className="header__logo">
            <span className="logo-icon">AI</span>
            <span className="logo-text">AICraft</span>
          </div>

          <nav className={`header__nav ${menuOpen ? 'header__nav--open' : ''}`}>
            <a href="#services" className="nav-link">服务</a>
            <a href="#pricing" className="nav-link">定价</a>
            <a href="#about" className="nav-link">关于</a>
            <a href="#contact" className="nav-link">联系</a>
          </nav>

          <div className="header__actions">
            <button className="btn btn--ghost">登录</button>
            <button className="btn btn--primary">开始使用</button>
          </div>

          <button 
            className="header__menu-toggle"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;

